import React from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import config from 'src/config';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BasicDetails from 'src/modules/profile/BasicDetails';

export default class ProfilePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            role: localStorage.getItem('role') || config.USER_ROLES.USER,
            value: 'profile'
        };
    }

    render() {
        return (

            <TabContext value={this.state.value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={(e, value) => {
                        this.setState({ value });
                    }} aria-label="lab API tabs example">
                        <Tab label="Profile" value="profile" icon={<AccountCircleIcon />} iconPosition="start"/>
                    </TabList>
                </Box>
                <TabPanel value="profile">
                    <BasicDetails
                        payload={{
                            type: 'container'
                        }}
                    />
                </TabPanel>
            </TabContext>
        );
    }
}
